import { normalize, schema } from 'normalizr';

import { createRetailTransformers } from 'pages/store/transformers/retail';

export const entity = 'ccTerminal';
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'ccTerminalID',
  }
);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);

// CCTerminal Transformer
export const { transformer, listTransformer } = createRetailTransformers('CCTerminal');
